module.exports = __webpack_public_path__ + "jab/media/azf.06645633.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/azf.svg
// module id = 1469
// module chunks = 0